(() => {
  function getOptionText(item) {
    const input = item.querySelector('input[data-option-value]');
    const label = item.querySelector('label');

    return (
      input?.dataset.optionValue ||
      input?.value ||
      label?.textContent ||
      item.textContent ||
      ''
    ).trim();
  }

  function textLength(text) {
    return Array.from(text.trim()).length;
  }

  function sortVariantOptions(root = document) {
    root.querySelectorAll('fieldset').forEach((fieldset) => {
      const list = fieldset.querySelector('ul');

      if (!list || !list.querySelector('.label-swatch')) return;

      const items = Array.from(list.children).map((item, index) => {
        const text = getOptionText(item);

        return {
          item,
          index,
          length: textLength(text)
        };
      });

      items.sort((a, b) => {
        return a.length - b.length || a.index - b.index;
      });

      items.forEach(({ item }) => list.appendChild(item));
    });
  }

  function runSort() {
    sortVariantOptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSort);
  } else {
    runSort();
  }

  document.addEventListener('shopify:section:load', (event) => {
    sortVariantOptions(event.target);
  });
})();